var _rect, _rect2, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 73,
    viewBox: "0 0 76 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.856384,
    width: 72.6257,
    height: 72.6257,
    rx: 8,
    fill: "#FFF1F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6738,
    y: 39.1316,
    width: 26.1066,
    height: 19.3751,
    fill: "#E31B56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3482 47.4633V44.1342H34.9937V47.4633H18.3482ZM18.3482 54.1215V50.7924H30V54.1215H18.3482ZM15.0191 60.7797C14.1036 60.7797 13.3196 60.454 12.6671 59.8026C12.0157 59.1501 11.69 58.3661 11.69 57.4506V34.147C11.69 33.2315 12.0157 32.448 12.6671 31.7966C13.3196 31.1441 14.1036 30.8179 15.0191 30.8179H16.6836V27.4888H20.0127V30.8179H33.3291V27.4888H36.6582V30.8179H38.3228C39.2383 30.8179 40.0223 31.1441 40.6748 31.7966C41.3262 32.448 41.6519 33.2315 41.6519 34.147V57.4506C41.6519 58.3661 41.3262 59.1501 40.6748 59.8026C40.0223 60.454 39.2383 60.7797 38.3228 60.7797H15.0191ZM15.0191 57.4506H38.3228V40.8051H15.0191V57.4506Z",
    fill: "#FF99B0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_68_1260)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.1852,
    y: 13.8726,
    width: 20.2256,
    height: 20.2256,
    rx: 10.1128,
    fill: "#FECBD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2659 26.5662C52.2659 25.5709 52.3551 24.8551 52.5336 24.4186C52.7115 23.9827 53.0892 23.5067 53.6667 22.9906C54.1705 22.5483 54.5543 22.1642 54.8182 21.8383C55.0827 21.513 55.2149 21.1414 55.2149 20.7236C55.2149 20.2199 55.046 19.8021 54.7084 19.4703C54.3702 19.1386 53.9001 18.9727 53.2981 18.9727C52.6714 18.9727 52.1952 19.1632 51.8693 19.5441C51.5439 19.925 51.3137 20.312 51.1785 20.7052L49.2802 19.8942C49.5382 19.1079 50.0112 18.4259 50.6993 17.8484C51.3874 17.2709 52.2537 16.9822 53.2981 16.9822C54.5882 16.9822 55.5805 17.3417 56.275 18.0607C56.969 18.7793 57.316 19.6424 57.316 20.6499C57.316 21.2643 57.184 21.7897 56.9201 22.2261C56.6557 22.6621 56.2408 23.1565 55.6756 23.7094C55.0736 24.2869 54.7081 24.7261 54.5794 25.0269C54.4501 25.3281 54.3855 25.8412 54.3855 26.5662H52.2659ZM53.2981 30.9896C52.8926 30.9896 52.5456 30.8453 52.2571 30.5568C51.9681 30.2678 51.8236 29.9206 51.8236 29.5151C51.8236 29.1096 51.9681 28.7624 52.2571 28.4734C52.5456 28.1849 52.8926 28.0407 53.2981 28.0407C53.7035 28.0407 54.0508 28.1849 54.3398 28.4734C54.6283 28.7624 54.7725 29.1096 54.7725 29.5151C54.7725 29.9206 54.6283 30.2678 54.3398 30.5568C54.0508 30.8453 53.7035 30.9896 53.2981 30.9896Z",
    fill: "#E21E58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_68_1260",
    x: 31.1852,
    y: 13.8726,
    width: 44.2256,
    height: 44.2256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_68_1260"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_1260"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_68_1260"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_68_1260",
    result: "effect2_dropShadow_68_1260"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_68_1260",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhen);
export default __webpack_public_path__ + "static/media/when.07288ad9e2555acf1ebcd5bc7deb223a.svg";
export { ForwardRef as ReactComponent };